import { ResponseError } from '../../errors';
import {
  TGetSearchCatalogLocationResponse,
  fetchGetSearchCatalogLocation,
} from '../../repositories/geo-temp-layer/v1/get-search-catalog-location';
import { IApplicationContext } from '../../types/applicationContext';

interface IParams {
  currentLocationId: number;
}

export const fetchHostByLocation = async (
  { httpApi, logger }: IApplicationContext,
  parameters: IParams,
): Promise<string | undefined> => {
  try {
    const responseData: TGetSearchCatalogLocationResponse = await fetchGetSearchCatalogLocation({
      httpApi,
      parameters,
    });

    if (responseData.statusCode !== 200) {
      throw new ResponseError({
        domain: 'fetchHostByLocation',
        message: responseData.response.message || 'Неизвестная ошибка',
        details: {
          errors: JSON.stringify(responseData.response.errors),
        },
      });
    }

    return responseData.response.baseHost;
  } catch (e) {
    logger.warning(e, { degradation: 'Не удалось запросить хост по локации' });

    return;
  }
};
